import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {v4 as uuidV4} from 'uuid';
import UserAuthentication from 'user/UserAuthentication';
import GuestLogin from './GuestLogin';

export default class CheckoutUserAuthentication extends Component {
    static propTypes = {
        user: PropTypes.object,
        referralSource: PropTypes.string.isRequired,
        onUserChange: PropTypes.func.isRequired,
        focusGuestLogin: PropTypes.bool,
        focusUserAuthentication: PropTypes.bool,
        showSignIn: PropTypes.bool,
    };
    state = {
        prevUser: this.props.user,
        userAuthenticationKey: uuidV4(),
        showLogin: false,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const {user, showSignIn} = nextProps;

        if (user.status !== prevState.prevUser.status) {
            return {
                userAuthenticationKey: uuidV4(),
                prevUser: user,
                showLogin: showSignIn,
            };
        }

        return null;
    }

    _onLoginToggle = evt => {
        this.setState(prevState => ({showLogin: !prevState.showLogin}));
    };

    render() {
        const {
            referralSource,
            onUserChange,
            focusGuestLogin,
            focusUserAuthentication,
        } = this.props;
        const {userAuthenticationKey, showLogin} = this.state;

        return (
            <div className="CheckoutUserAuthentication">
                {showLogin ? (
                    <UserAuthentication
                        ref={node => {
                            this._checkoutUserAuthentication = node;
                        }}
                        key={userAuthenticationKey}
                        referralSource={referralSource}
                        focus={focusUserAuthentication}
                        onLoginToggle={this._onLoginToggle}
                        onUserChange={onUserChange}
                    />
                ) : (
                    <GuestLogin
                        focus={focusGuestLogin}
                        onLoginToggle={this._onLoginToggle}
                        onUserChange={onUserChange}
                    />
                )}
            </div>
        );
    }
}
